module.exports = __webpack_public_path__ + "static/img/bg_9.222354c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg_9.jpg
// module id = xnvi
// module chunks = 1